import React from "react";

export function SystemError({error_msg}) {
    return (
        <div className="validation-error-box">
            <p>{error_msg}</p>
        </div>
    );
}